import { createContext, useContext, useEffect } from 'react';
import { AggregateEuRootResponse } from 'src/apis/aggregate-eu/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleRequestError } from 'src/utils/axios-config';

export function useAggregateEuRequest() {
  const aggregateEuRoot = useAxios(
    (axios, signal) =>
      axios.request<AggregateEuRootResponse>({
        signal,
        url: PRISMA_CONFIG.aggregateEu,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        const [_, report] = handleRequestError(error, () => {});
        if (report) reportError(error);
        return error;
      },
    }
  );

  useEffect(() => {
    aggregateEuRoot.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return aggregateEuRoot;
}

export type AggregateEuRequest = ReturnType<typeof useAggregateEuRequest>;

const AggregateEuContext = createContext<AggregateEuRootResponse | undefined>(
  undefined
);

export const AggregateEuProvider = AggregateEuContext.Provider;

export function useAggregateEu() {
  return useContext(AggregateEuContext);
}
